// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2pUvY","buttons":"RemoveExpirationActionButtons_buttons__3d--_"};